import { useSelector } from 'react-redux';
import { getProjectEntitlement } from '../../../project/selectors';
import type { ProjectSlice } from '../../../project/types';
import { getDefaultLocaleInitialData, getLocalesState, getLocalesTableData } from '../../selectors';
import type { LocalesHookProps } from './locales';

export const useLocales = (): LocalesHookProps => {
  const localesEntitlement = useSelector((state: ProjectSlice) =>
    getProjectEntitlement(state, { entitlement: 'locales' })
  ) as number;
  const localesState = useSelector(getLocalesState);
  const isSaving = localesState.get('saving');
  const locales = useSelector(getLocalesTableData);
  const defaultLocaleInitialData = useSelector(getDefaultLocaleInitialData);

  return { localesEntitlement, isSaving, locales, defaultLocaleInitialData };
};
